var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActivityDetailsCard',{attrs:{"activityType":_vm.item.type,"title":_vm.item.description}})
}
var staticRenderFns = []

export { render, staticRenderFns }